import { authPostRequest, getAuthRequest } from 'Api/api';
import { getImagesDataWithMaterialsPrices } from './fenceCalculatorUtils';
import { CALCULATOR_MAX_INPUT_VAL } from 'constant/constants';

export const fieldType = { singleSelect: 'select', number: 'number' };
/**
 *
 * @param {string} name
 * @param {string} value
 * @param {number} min
 * @param {number} max
 * @param {function} handleError
 * @returns {boolean} true if error exists
 */
export const handleInputValidation = (name, value, min = null, max = null, handleError) => {
  if (name == 'barSystem' && value != 1 && value != 2 && value != 3) {
    handleError(name, 'enter value 1, 2 or 3 ');
    return true;
  }
  if (!isNaN(min)) {
    if (value < min) {
      handleError(name, 'enter value greater than or equal to ' + min);
      return true;
    }
  }
  if (!isNaN(max)) {
    if (value > max) {
      handleError(name, 'enter value less than or equal to ' + max);
      return true;
    }
  }
  if (!value) {
    handleError(name, 'enter value');
    return true;
  }
  handleError(name, null);
  return false;
};

/**
 * It is check if the current bracket for fence is a
 * clamp-on to skip the Fastener step
 *
 * @param {map} fenceState main state of fence calculator
 * @returns {boolean} true if snow fence is a clamp-on
 */
export const isNameInSate = (fenceState, name, key) => {
  return fenceState?.get(key)?.name?.includes(name);
};

const getFenceData = async (roofTypeId, constructionTypeId) => {
  const params = [roofTypeId, constructionTypeId];
  const fenceData = await functions.getFence(params);
  return fenceData;
};

export const updateNewStateManuallyForSkippedSteps = (newState, key, handleChange) => {
  newState.value = newState.data[0]?.id;
  newState.apiCalled = true;
  newState.name = newState.data[0]?.name;
  handleChange(key, newState.value, newState.name, null, null);
};

export const sortFences = async (
  bracketsPriceDataList,
  sortByMaterial,
  setUpdatedData,
  fenceCalculatorState,
  setDataForCart,
  isCalcInEditMode,
  setBarSystemValue
) => {
  let bracketImagesWithPrices = [];
  if (isCalcInEditMode) {
    bracketImagesWithPrices = await getFenceData(
      fenceCalculatorState.get(0)?.value,
      fenceCalculatorState.get(1)?.value
    );
  } else {
    let data = fenceCalculatorState.get(2)?.data;
    bracketImagesWithPrices = getImagesDataWithMaterialsPrices(
      data,
      bracketsPriceDataList,
      sortByMaterial
    );
  }

  fenceCalculatorState?.size === 3 && setUpdatedData(bracketImagesWithPrices);
  if (isCalcInEditMode) {
    setDataForCart(bracketImagesWithPrices);
    return;
  }
  const filteredData =
    bracketImagesWithPrices &&
    bracketImagesWithPrices?.filter((data) => data?.materials?.length > 0);

  const selectedBracket = filteredData.filter(
    (obj) => obj.id === fenceCalculatorState.get(2)?.value
  );
  //set the bar system for submission
  setBarSystemValue(selectedBracket[0]?.barSystem);
  if (filteredData?.length > 0) {
    setDataForCart(filteredData);
  }
};

export const setCartDataforAdd = (
  data,
  bracketType,
  material,
  outputs = [],
  systemComponents,
  editMode = false,
  barSystemVal,
  selectedBrktPrice
) => {
  const selectedBracket = data?.filter((obj) => obj.id === bracketType);
  const materialArray = selectedBracket?.map((obj) =>
    obj.materials?.filter((obj) => obj.materialId === material)
  );

  function getFirstObject(arrayOfArrays) {
    if (!arrayOfArrays) return null;
    for (const array of arrayOfArrays) {
      if (array?.length > 0) {
        return array[0];
      }
    }
    // If no object is found, return null or handle accordingly
    return null;
  }

  const firstObject = editMode ? null : getFirstObject(materialArray);

  const cartProps = {
    unitPrice: editMode ? selectedBrktPrice : firstObject?.price,
    outputs: outputs,
    bracketMaterial: editMode
      ? material?.material
      : materialArray.length > 0 && firstObject?.material,
    bracketType: selectedBracket[0]?.name,
    iconUrl: selectedBracket[0]?.iconURL || '/productImgs/placeholder.png',
    systemComponents,
    barSystemVal
  };

  return cartProps;
};

export const getSystemComponents = async (reqObj) => {
  try {
    const componentsRes = await authPostRequest('getAssociatedSystemComponents', reqObj);
    if (componentsRes?.resStatus == 1) {
      const compsList = componentsRes?.systemComponentsList;
      return compsList;
    }
    return [];
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const getSelectedBrktPrice = (prices, bracketAndMaterialData) => {
  const bracket = prices?.filter(
    (bracket) => bracket.bracketId == bracketAndMaterialData.bracketTypeId
  );
  const material = bracket[0]?.materials?.filter(
    (material) => material.materialId == bracketAndMaterialData.bracketMaterialId
  );

  return material[0]?.price || 0;
};

export const functions = {
  getRoofTypes: async () => {
    try {
      const roofTypes = await getAuthRequest('getAllAssociatedRoofTypes');
      return roofTypes;
    } catch (err) {
      console.log(err);
    }
  },

  getConstruction: async (requestParams) => {
    const params = {
      roofTypeId: requestParams[0]
    };
    try {
      const constructionTypes = await authPostRequest('getConstructionTypeByRoofType', params);
      return constructionTypes;
    } catch (err) {
      console.log(err);
    }
  },

  getFence: async (requestParams) => {
    const params = {
      roofTypeId: requestParams[0],
      constructionTypeId: requestParams[1]
    };
    try {
      const fenceTypes = await authPostRequest('getBracketsByRoofTypeAndConstructionType', params);
      return fenceTypes;
    } catch (err) {
      console.log(err);
    }
  },

  getSeam: async (requestParams) => {
    const params = {
      roofTypeId: requestParams[0],
      constructionTypeId: requestParams[1],
      bracketId: requestParams[2]
    };
    try {
      const seamTypes = await authPostRequest(
        'getSeamsByRoofTypeAndConstructionTypeAndBracketType',
        params
      );
      return seamTypes;
    } catch (err) {
      console.log(err);
    }
  },

  getMaterial: async (requestParams) => {
    const params = {
      roofTypeId: requestParams[0],
      constructionTypeId: requestParams[1],
      bracketId: requestParams[2],
      seamTypeId: requestParams[4]
    };
    try {
      const materialType = await authPostRequest(
        'getMaterialsByRoofTypeAndConstructionTypeAndBracketType',
        params
      );
      return materialType;
    } catch (err) {
      console.log(err);
    }
  },
  getFastener: async (requestParams) => {
    const params = {
      roofTypeId: requestParams[0],
      constructionTypeId: requestParams[1],
      bracketId: requestParams[2],
      seamTypeId: requestParams[4],
      materialTypeId: requestParams[3]
    };
    try {
      const fasteerTypes = await authPostRequest(
        'getFastenersByRoofTypeAndConstructionTypeAndBracketTypeAndMaterialType',
        params
      );
      return fasteerTypes;
    } catch (err) {
      console.log(err);
    }
  },
  getSheathing: async (requestParams) => {
    const params = {
      roofTypeId: requestParams[0],
      constructionTypeId: requestParams[1],
      bracketId: requestParams[2],
      seamTypeId: requestParams[4],
      materialTypeId: requestParams[3],
      fastenerTypeId: requestParams[5]
    };
    try {
      const sheathingTypes = await authPostRequest(
        'getSheathingsByRoofTypeAndConstructionTypeAndBracketTypeAndMaterialTypeAndFastenerType',
        params
      );

      return sheathingTypes;
    } catch (err) {
      console.log(err);
    }
  },
  getBrktStrength: async (stringForApi) => {
    const normal = [
      stringForApi[2],
      stringForApi[3],
      stringForApi[6],
      stringForApi[5],
      stringForApi[4]
    ];
    const arry = [];
    normal.map((arr) => arr && arry.push(arr));

    try {
      const strength = await authPostRequest('findStrength', {
        combination: arry.join(' ')
      });
      return Number(strength?.strengthValue);
    } catch (err) {
      console.log(err);
    }
  }
};

export const fenceCalculatorUIFieldStructure = [
  {
    label: 'Roof Type',
    key: 'roofTypeId',
    name: 'roofType',
    type: fieldType.singleSelect,
    api: 'getRoofTypes'
  },
  {
    label: 'Construction Type',
    key: 'constructionTypeId',
    name: 'constructionType',
    type: fieldType.singleSelect,
    api: 'getConstruction'
  },
  {
    label: 'Fence Type',
    key: 'bracketTypeId',
    name: 'bracketType',
    type: fieldType.singleSelect,
    api: 'getFence'
  },
  {
    label: 'Material Type',
    key: 'bracketMaterialId',
    name: 'bracketMaterial',
    type: fieldType.singleSelect,
    api: 'getMaterial'
  },
  {
    label: 'Seam Type',
    key: 'seamTypeId',
    name: 'seamType',
    type: fieldType.singleSelect,
    api: 'getSeam'
  },
  {
    label: 'Fastener Type',
    key: 'fastenerTypeId',
    name: 'fastenerType',
    type: fieldType.singleSelect,
    api: 'getFastener'
  },
  {
    label: 'Sheathing Type',
    key: 'roofSheathingTypeId',
    name: 'roofSheathingType',
    type: fieldType.singleSelect,
    api: 'getSheathing'
  },
  // 0 - 6
  {
    label: 'Bracket Strength', // 7
    key: 'strength',
    type: fieldType.number,
    api: 'getBrktStrength',
    readOnly: true,
    disabled: true
  },
  {
    label: 'Width of Panel or Rafter Spacing (inches)',
    key: 'widthOfPanel',
    type: fieldType.number,
    placeholder: 'Enter width or spacing (inches)',
    required: true,
    min: 1,
    max: CALCULATOR_MAX_INPUT_VAL
  },
  {
    label: 'Length of Panel (feet)',
    key: 'lengthOfPanel',
    type: fieldType.number,
    placeholder: 'Enter panel Length (feet)',
    required: true,
    min: 1,
    max: CALCULATOR_MAX_INPUT_VAL
  },
  {
    label: 'Roof Pitch (x/12)',
    key: 'roofSlope',
    type: fieldType.number,
    placeholder: 'Enter roof pitch (x/12)',
    required: true,
    min: 1,
    max: 18
  },
  {
    label: 'Ground Snow Load (Per Square Foot)',
    key: 'groundSnowLoad',
    type: fieldType.number,
    placeholder: 'Enter ground snow load',
    required: true,
    min: 1,
    max: 700
  },
  {
    label: 'Rain Load (Per Square Foot) - Canada Only',
    min: 0,
    max: 100,
    key: 'rainLoad',
    type: fieldType.number,
    placeholder: 'Enter rain load'
  },
  {
    label: 'Eave Length (feet)',
    key: 'eaveLength',
    type: fieldType.number,
    placeholder: 'Enter eave length',
    required: true,
    min: 1,
    max: 3000
  },
  {
    label: 'One, Two or Three Bar System',
    key: 'barSystem',
    type: fieldType.number,
    placeholder: 'Enter bar systsem',
    readOnly: true,
    required: true,
    min: 1,
    max: CALCULATOR_MAX_INPUT_VAL
  }
];

export const outputArray = [
  {
    label: 'Number of fences needed (per panel)',
    name: 'fencesNeeded'
  },
  {
    label: 'Maximum Length requiring 1 fence (feet)',
    name: 'lengthRequiringOneFence'
  },
  {
    label: 'Maximum Length requiring 2 fences (feet)',
    name: 'lengthRequiringTowFences'
  },
  {
    label: 'Distance Between 1st and 2nd Fence',
    name: 'distanceBetweenFences'
  },
  {
    label: 'Distance Between Additional Fences/Ridge',
    name: 'distanceBetweenAdditionalFences'
  },
  {
    label: 'Number of Brackets',
    name: 'numberOfBrackets'
  },
  {
    label: 'Number of Tubing',
    name: 'numberOfTubing'
  },
  {
    label: 'Stop Ends Accessories',
    name: 'stopEndsAccessories'
  },
  {
    label: 'Ice Flags',
    name: 'iceFlags'
  }
];
